module.exports = __webpack_public_path__ + "audio-740dcc25c5ba.m4a";